import React from 'react';
import FacebookPanelDPC from "./dpc-fabeook-panel-inr";
import TwitterPanelDPC from "./dpc-twitter-panel-inr";

export default ({children, checkFacebook, checkTwitter, isMinisito, titolo, listaSocial}) => (
    <div className={isMinisito? "col-12 col-sm-6 col-xl-12": "col-12 col-md-6 col-xl-4"}>
        {typeof document !== `undefined` /*&& document.cookie.indexOf('cookies_consent=true') >= 0*/ ?
            <aside aria-label="pannello social">
                <h2>{titolo ? titolo : 'Social'}</h2>
                {listaSocial.map( item =>
                    item === 'Facebook' ? 
                        <FacebookPanelDPC/>
                    :
                    item === 'Twitter' ? 
                        <TwitterPanelDPC/>
                    :
                    null
                )
                }
            </aside> : null}
    </div>

);
